import ThreeUp from "../../components/ThreeUp";
import ThreeUpItem from "../../components/ThreeUp/components/ThreeUpItem";
import GridItem from "../../components/general/GridItem";
import { getUrlFromStoryblokLink } from "../../utils/storyblok/urls";
import { notUndefined } from "../../utils/type-guards/general";

const TwoUpModule = ({
	headline,
	label,
	items,
}: Queries.ThreeUpModuleFragment) => {
	const itemsProps = items
		?.map((item) => {
			if (!item || !item.image) return;

			const button = item.button?.[0];
			const buttonProps =
				button && button.link && typeof button.label === "string"
					? {
							href: getUrlFromStoryblokLink(button.link),
							label: button.label,
							icon: button.icon ?? undefined,
						}
					: undefined;

			return {
				uid: item._uid,
				headline: item.headline ?? "",
				image: item.image,
				text: item.text ?? "",
				cta: buttonProps ?? undefined,
			};
		})
		.filter(notUndefined);

	return itemsProps ? (
		<GridItem>
			<ThreeUp
				headline={headline ?? ""}
				label={label ?? ""}
				notThree={itemsProps.length < 3}
			>
				{itemsProps.map((item) => (
					<ThreeUpItem
						key={item.uid}
						image={item.image}
						headline={item.headline}
						text={item.text}
						cta={item.cta}
						notThree={itemsProps.length < 3}
					/>
				))}
			</ThreeUp>
		</GridItem>
	) : null;
};

export default TwoUpModule;
